
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import {
    ADD_COMMAND
} from './map';

import {
    CATEGORY_OPERATION_ACTION_TYPE
} from './category';

import getPromiseCallback from '../common/client/utils/getPromiseCallback';

export const LIST_OPERATION_ACTION_TYPE = createActionTypes('list/OPERATION');
export const LIST_ADD_ACTION_TYPE = 'list/ADD';
export const LIST_EXEC_ACTION_TYPE = 'list/EXEC';
export const LIST_GET_ACTION_TYPE = 'list/GET';
export const LIST_REMOVE_ACTION_TYPE = 'list/REMOVE';

export default function getActions(dispatch) {
    return {
        listAdd: (token, projectId, listName, parId) => dispatch({
            type: LIST_ADD_ACTION_TYPE, operation: 'ADD', token, projectId, listName, parId
        }),
        listGet: (token, projectId) => dispatch({
            type: LIST_GET_ACTION_TYPE, token, projectId
        }),
        listRemove: (token, projectId, listName, parId) => dispatch({
            type: LIST_REMOVE_ACTION_TYPE, operation: 'REMOVE', token, projectId, listName, parId
        })
    };
}

function listExec(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'listExec',
            token: action.token,
            body: {
                params: {
                    operation: action.operation,
                    projectId: action.projectId,
                    listName: action.listName,
                    parId: action.parId
                }
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function listGet(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'listGet',
            token: action.token,
            body: {
                params: {
                    projectId: action.projectId
                }
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function* workListAdd(options, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: 'Přidávám parcely do seznamu'});
        yield put({type: LIST_OPERATION_ACTION_TYPE.DEFAULT});
        yield put({type: LIST_OPERATION_ACTION_TYPE.LOADING});
        const data = yield call(listExec, options.serverApi, action);
        yield put({type: LIST_OPERATION_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: 'Přidání parcel do seznamu'});
        yield put({type: ADD_COMMAND, name: 'REDRAW', params: {layers: ['category_parcela', 'category_cluster']}});
    } catch (error) {
        yield call(setOperationError, error, LIST_OPERATION_ACTION_TYPE);
    }
}

export function* watchListAdd(options) {
    yield takeEvery(LIST_ADD_ACTION_TYPE, workListAdd, options);
}

function* workListGet(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: LIST_OPERATION_ACTION_TYPE.DEFAULT});
        yield put({type: LIST_OPERATION_ACTION_TYPE.LOADING});
        const data = yield call(listGet, options.serverApi, action);
        yield put({type: LIST_OPERATION_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, LIST_OPERATION_ACTION_TYPE);
    }
}

export function* watchListGet(options) {
    yield takeEvery(LIST_GET_ACTION_TYPE, workListGet, options);
}

function* workListRemove(options, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: 'Odstraňuji parcely ze seznamu'});
        yield put({type: LIST_OPERATION_ACTION_TYPE.DEFAULT});
        yield put({type: LIST_OPERATION_ACTION_TYPE.LOADING});
        const data = yield call(listExec, options.serverApi, action);
        yield put({type: LIST_OPERATION_ACTION_TYPE.SUCCESS, data});
        yield put({type: CATEGORY_OPERATION_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: 'Odstranění parcel ze senamu'});
        yield put({type: ADD_COMMAND, name: 'REDRAW', params: {layers: ['category_parcela', 'category_cluster']}});
    } catch (error) {
        yield call(setOperationError, error, LIST_OPERATION_ACTION_TYPE);
    }
}

export function* watchListRemove(options) {
    yield takeEvery(LIST_REMOVE_ACTION_TYPE, workListRemove, options);
}
